import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import { router } from "./router";
import { consoleDomains, isLocalConsoleHost } from "./console-domain";
import "./styles.css";

const firstPathSegment = window.location.pathname.split("/").filter(Boolean)[0];
const hasLocalEntry = consoleDomains.some(
  (domain) => domain === firstPathSegment,
);

if (import.meta.env.DEV && isLocalConsoleHost() && !hasLocalEntry) {
  const canonical = new URL(window.location.href);
  canonical.pathname = `/admin${canonical.pathname}`;
  window.location.replace(canonical);
} else {
  createApp(App).use(createPinia()).use(router).mount("#app");
}
